import { ReconfigureAgentPanelController } from '../controller/ReconfigureAgentPanelController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';

export class ReconfigureAgentPanelWebComponent extends BaseWebComponentElement {
  public controller!: ReconfigureAgentPanelController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: ReconfigureAgentPanelController,
    });
  }
}
